import { InputHTMLAttributes, ReactNode } from 'react'
import { ReactSVG } from 'react-svg'

import { cn } from '@shared/lib/cn'

import styles from './styles.module.scss'



interface CheckboxProps extends InputHTMLAttributes<HTMLInputElement> {
  checkboxSize?: 'extra_small' | 'small' | 'medium' | 'large';
  label?: ReactNode;
}

export default function Checkbox (props: CheckboxProps) {
  const { checkboxSize = 'medium', label, className, ...rest } = props

  return (
    <label className={cn(styles.root, styles[checkboxSize], className)}>
      <input className={styles.input} type="checkbox" {...rest} />
      <span className={styles.icon}>
        <ReactSVG
          src="/icons/check.svg"
          className={styles.check}
          wrapper="span"
        />
      </span>
      {label && <span className={styles.label}>{label}</span>}
    </label>
  )
}
